export const SIGN_IN = "sign_in";
export const SIGN_OUT = "sign_out";
export const ACCESS_TOKEN = "accessToken";
export const CALLBACK_URL = "callbackUrl";
export const ADD_DETAILS = "add_details";
